import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Container, Grid, Card, CardContent, CardMedia, Typography, Button, Box } from '@mui/material';
import { useNavigate } from 'react-router-dom';

const Home = () => {
    const [ads, setAds] = useState([]);
    const navigate = useNavigate();

    useEffect(() => {
        const fetchAds = async () => {
            try {
                const response = await axios.get('https://api.typecopy.co.za/api/Ads');
                setAds(response.data.slice(0, 6)); // Limit to top 6 ads
            } catch (error) {
                console.error('Error fetching ads:', error);
            }
        };

        fetchAds();
    }, []);

    const handleAdClick = (id) => {
        navigate(`/ads/${id}`);
    };

    return (
        <Container sx={{ paddingTop: 0 }}>
            <Box textAlign="center" mb={4}>
                <Typography variant="h3" gutterBottom>
                    Type Copy
                </Typography>
                <Typography variant="body1" gutterBottom>
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.
                    Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure
                    dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non
                    proident, sunt in culpa qui officia deserunt mollit anim id est laborum.
                </Typography>
            </Box>
            <Grid container spacing={4}>
                {ads.map((ad) => (
                    <Grid item key={ad.id} xs={12} sm={6} md={4}>
                        <Box onClick={() => handleAdClick(ad.id)} sx={{ cursor: 'pointer' }}>
                            <Card sx={{ borderRadius: 2, boxShadow: 3 }}>
                                <CardMedia
                                    component="img"
                                    height="200"
                                    image={ad.imageUrl}
                                    alt={ad.title}
                                    sx={{ borderTopLeftRadius: 8, borderTopRightRadius: 8 }}
                                />
                                <CardContent>
                                    <Typography gutterBottom variant="h5" component="div">
                                        {ad.title}
                                    </Typography>
                                    <Typography variant="body2" color="text.secondary">
                                        {ad.niche}
                                    </Typography>
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        onClick={() => handleAdClick(ad.id)}
                                        sx={{ mt: 2, borderRadius: 2 }}
                                    >
                                        View Ad
                                    </Button>
                                </CardContent>
                            </Card>
                        </Box>
                    </Grid>
                ))}
            </Grid>
        </Container>
    );
};

export default Home;